import { roundWith2Decimals } from './pmiHeroChartDataConverter';

export const taxonomyMapperDataConverter = {
	convert(data, isIndirectSpend = false) {
		const stack = [];
		const result = [];

		// for direct spend case - there is no tail, so no need to combine tail spend
		const correctedData = isIndirectSpend ? combineTailSpendValues(data) : data;

		correctedData.forEach(dataItem => {
			if (dataItem.isTailVendorsNode) {
				return;
			}

			if (!dataItem.label) {
				return;
			}

			const convertedItem = convertListItem(dataItem);
			if (stack.length) {
				while (stack.length) {
					let parentItem = stack[stack.length - 1];

					if (parentItem.id === dataItem.parentId) {
						parentItem.children.push(convertedItem);
						stack.push(convertedItem);
						break;
					} else {
						stack.pop();
					}
				}

				if (!stack.length) {
					result.push(convertedItem);
					stack.push(convertedItem);
				}
			} else {
				result.push(convertedItem);
				stack.push(convertedItem);
			}
		});

		return result;
	},
};

export const convertListItem = item => {
	const { label, id, parentId } = item;
	const value = roundWith2Decimals(item.value);

	const result = {
		id,
		originalId: id,
		name: label,
		title: label,
		expanded: false,
		parentId,
		value,
		children: [],
	};

	if (item.depth) {
		result.level = item.depth - 1;
	}

	return result;
};

const combineTailSpendValues = data => {
	const corrected = data.map(item => {
		if (!item.isTailVendorsNode) {
			return {
				...item,
				value: item.value + item.tailValue,
			};
		}

		return item;
	});

	return corrected;
};
